import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { DialogBase, ObjectTypeClassInfo } from 't4core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, NgModel, Validators } from '@angular/forms';
import { ObjectTypeClassAttributesInfo } from '../../../../../projects/t4core/src/public-api';
import { ObjectTypeClassAttributeDialog } from '../../dialogs/ObjectTypeClassAttributeDialog/ObjectTypeClassAttributeDialog';

@Component({
  styleUrls: ['CreateObjectTypeClassDialog.css'],
  selector: 'CreateObjectTypeClassDialog',
  templateUrl: 'CreateObjectTypeClassDialog.html',
})

export class CreateObjectTypeClassDialog extends DialogBase {
 
  public objectTypeClassAttributes: ObjectTypeClassAttributesInfo[];
  public objectTypeclasses: ObjectTypeClassInfo[] = [];
  public selectedClassId = null;
  public isLoading: boolean = false;
  public otc: ObjectTypeClassInfo;
  public overidden: ObjectTypeClassInfo[];

  constructor(
    public dialogRef: MatDialogRef<CreateObjectTypeClassDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { objectTypeClass: ObjectTypeClassInfo, editable: boolean }
  ) {
    super("CreateObjectTypeClassDialog");
  }
  public async ngOnInit() {
    this.isLoading = true;
    if (this.data.objectTypeClass) {
      this.otc = this.data.objectTypeClass;
    }
    else {
      this.otc = new ObjectTypeClassInfo;
    }
    await this.getObjectTypeClassInfo();
    this.isLoading = false;

  }
  public async getObjectTypeClassInfo() {
    var res = await this.Api.get<ObjectTypeClassInfo[]>("Settings/GetDefaultObjectTypeClasses");
    this.objectTypeclasses = res;
  }
  public async save() {
    this.otc.OverridesClassId = this.selectedClassId;
    var token = this.UI.beginLoading("T4.Settings.CreateObjectTypeClassDialog.msgCreating", "Saving Object Type class", null);
    var res = await this.Api.post<any>("Settings/SaveObjectTypeClass", this.otc);
    this.dialogRef.close(res);
    this.UI.loaderCompleted(token);
  }
  public async onOverridenClassSelected(selectedId: number) {
    this.selectedClassId = selectedId;
    if (selectedId != null) {
      var allObjectTypeClassses = await this.Api.get<ObjectTypeClassInfo[][]>("Settings/GetAllObjectTypeClasses");
      this.overidden = allObjectTypeClassses[1].filter(o => o.OverridesClassId == selectedId);
      this.objectTypeClassAttributes = this.overidden[0].Attributes;
    }
  }
}
